<template>
  <md-card-content>
    <!-- 決済方法 -->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>決済方法</label>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-radio v-model="form.bill_method" v-bind:key="'building-method-key-' + billingMethod"
                  v-for="(billingMethodName, billingMethod) in billingMethods"
                  :value="billingMethod" required name="billingMethod" @change="onChangeBillingMethod"
                  :disabled="!activated || sending">
          {{ billingMethodName }}
        </md-radio>
      </div>
    </div>

    <!-- カード情報 -->
    <div class="md-layout md-gutter" v-if="showCardInformation()">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>カード情報</label>
      </div>
      <div class="md-layout-item md-size-40 md-small-size-100">
        <md-field :class="getValidationClass('cardNumber')">
          <label>カード情報</label>
          <md-input name="cardNumber" required type="card" v-model="form.cardNumber"
                    :disabled="!activated || sending" maxlength="20"></md-input>
          <span class="md-helper-text">例) 1111222233334444、※ "-" ハイフンは不要です</span>
          <span class="md-error" v-if="getValidationResponseMessage('cardNumber')">
            {{ getValidationResponseMessage('cardNumber') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.cardNumber.required">
            {{ errors.cardNumber.required }}
          </span>
          <span class="md-error" v-else-if="!$v.form.cardNumber.numeric">
            {{ errors.cardNumber.numeric }}
          </span>
          <span class="md-error" v-else-if="!$v.form.cardNumber.minLength">
            {{ errors.cardNumber.minLength }}
          </span>
          <span class="md-error" v-else-if="!$v.form.cardNumber.maxLength">
            {{ errors.cardNumber.maxLength }}
          </span>
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter" v-if="showCardInformation()">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100"></div>
      <div class="md-layout md-layout-item md-size-30 md-small-size-100">
        <div class="md-layout md-layout-item md-alignment-center-left md-size-40">
          <label>有効期限</label>
        </div>
        <md-field class="md-layout-item md-size-50" :class="getValidationClass('cardExpireMonth')">
          <md-select name="cardExpireMonth" required :disabled="!activated || sending" v-model="form.cardExpireMonth">
            <md-option v-for="(month, index) in months" :value="month" :key="index">
              {{ month }}
            </md-option>
          </md-select>
          <span class="md-error" v-if="!$v.form.cardExpireMonth.required">
            {{ errors.cardExpireMonth.required }}
          </span>
        </md-field>
        <div class="md-layout md-layout-item md-alignment-center md-size-5">
          <label>月</label>
        </div>
      </div>
      <div class="md-layout md-layout-item md-size-30 md-small-size-100">
        <md-field class="md-layout-item md-size-50" :class="getValidationClass('cardExpireYear')">
          <md-select name="cardExpireYear" required :disabled="!activated || sending" v-model="form.cardExpireYear">
            <md-option v-for="year in years()" :value="year" :key="'year-' + year">
              {{ year }}
            </md-option>
          </md-select>
          <span class="md-error" v-if="!$v.form.cardExpireYear.required">
            {{ errors.cardExpireYear.required }}
          </span>
        </md-field>
        <div class="md-layout md-layout-item md-alignment-center md-size-5">
          <label>年</label>
        </div>
      </div>
    </div>
    <div class="md-layout md-gutter" v-if="showCardInformation()">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100"></div>
      <div class="md-layout-item md-size-40 md-small-size-100">
        <md-field :class="getValidationClass('cardHolder')">
          <label>名義人（任意）</label>
          <md-input :disabled="!activated || sending" name="cardHolder" v-model="form.cardHolder"></md-input>
          <span class="md-helper-text">例) TARO JON</span>
          <span class="md-error" v-if="getValidationResponseMessage('cardHolder')">
            {{ getValidationResponseMessage('cardHolder') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.cardHolder.cardHolder">
            {{ errors.cardHolder.cardHolder }}
          </span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-30 md-small-size-100" v-if="showCardInformation()">
        <md-field :class="getValidationClass('cardSecurityCode')">
          <label>セキュリティコード（任意）</label>
          <md-input :disabled="!activated || sending" maxlength="4" name="cardSecurityCode"
                    v-model="form.cardSecurityCode"></md-input>
          <span class="md-helper-text">例) 1234</span>
          <span class="md-error" v-if="getValidationResponseMessage('cardSecurityCode')">
            {{ getValidationResponseMessage('cardSecurityCode') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.cardSecurityCode.numeric">
            {{ errors.cardSecurityCode.numeric }}
          </span>
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter" v-if="getCardErrorMessage()">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100"></div>
      <div class="md-layout-item md-size-80 md-small-size-100">
        <flash-message :errors="[form.cardError]"></flash-message>
      </div>
    </div>
  </md-card-content>
</template>

<script>
import Common                                    from "../../modules/common";
import moment                                    from 'moment';
import CommonMixin                               from "../../mixins/commonMixin";
import ContractFormMixin                         from "../../mixins/contractFormMixin";
import {validationMixin}                         from "vuelidate";
import Validation                                from "../../modules/validation";
import {maxLength, minLength, numeric, required} from "vuelidate/lib/validators";
import FlashMessage                              from "../FlashMessage";
import GMO                                       from "../../modules/gmo";

export default {
  name      : 'ContractFormPayment',
  components: {FlashMessage},
  props     : ['value', 'activated'],
  mixins    : [CommonMixin, ContractFormMixin, validationMixin],
  data      : () => ({
    billingMethods   : Common.billingMethods,
    months           : Common.allMonths,
    showCardInfoBlock: true,
    form             : {
      bill_method     : Common.billingMethodCreditCard,
      cardToken       : null,
      cardNumber      : null,
      cardExpireMonth : null,
      cardExpireYear  : moment().year(),
      cardHolder      : null,
      cardSecurityCode: null,
      cardError       : null,
    },
    errors           : {
      bill_method     : {
        required: Validation.errorMessage(Validation.rules.required, 'paymentBillMethod'),
      },
      cardNumber      : {
        required : Validation.errorMessage(Validation.rules.required, 'paymentCardNumber'),
        minLength: Validation.errorMessage(Validation.rules.minLength, 'paymentCardNumber', 14),
        maxLength: Validation.errorMessage(Validation.rules.maxLength, 'paymentCardNumber', 16),
        numeric  : Validation.errorMessage(Validation.rules.numeric, 'paymentCardNumber'),
      },
      cardExpireMonth : {
        required: Validation.errorMessage(Validation.rules.required, 'paymentCardExpiredMonth'),
      },
      cardExpireYear  : {
        required: Validation.errorMessage(Validation.rules.required, 'paymentCardExpiredYear'),
      },
      cardHolder      : {
        cardHolder: Validation.errorMessage(Validation.rules.cardHolder, 'cardHolder'),
      },
      cardSecurityCode: {
        numeric  : Validation.errorMessage(Validation.rules.numeric, 'paymentCardSecurityCode'),
        maxLength: Validation.errorMessage(Validation.rules.max, 'paymentCardSecurityCode', 4),
      },
    },
  }),
  validations() {
    return {
      form: {
        bill_method     : {
          required,
        },
        cardNumber      : {
          required,
          minLength: minLength(14),
          maxLength: maxLength(16),
          numeric,
        },
        cardExpireMonth : {
          required,
        },
        cardExpireYear  : {
          required,
        },
        cardHolder      : {
          cardHolder: Validation.cardHolder,
        },
        cardSecurityCode: {
          numeric,
        },
      },
    };
  },
  mounted() {
    GMO.importGmoPGLibrary().catch(() => { /* 取得時に再試行し、既存のエラー表示へ渡す */ });
  },
  methods: {
    async validate() {
      this.$v.$reset();
      this.$v.form.bill_method.$touch();
      if (this.form.bill_method === Common.billingMethodCreditCard) {
        this.$v.form.cardNumber.$touch();
        this.$v.form.cardExpireMonth.$touch();
        this.$v.form.cardExpireYear.$touch();
        this.$v.form.cardHolder.$touch();
        this.$v.form.cardSecurityCode.$touch();
        this.validated = !this.$v.$invalid;
        // NOTE: frontend/src/views/contract/ContractApply.vue に本人認証処理あり
      } else {
        this.validated = !this.$v.form.bill_method.$invalid;
      }
    },
    years() {
      let maxYear = moment().add(10, 'years').year();
      let minYear = moment().subtract(50, 'years').year();
      return _.range(maxYear, minYear, -1);
    },
    onChangeBillingMethod: function () {
      this.$emit('changeBillMethod', this.form.bill_method)
    },
    showCardInformation() {
      return this.form.bill_method === Common.billingMethodCreditCard;
    },
    getCardErrorMessage() {
      for (let index in this.validateResponse) {
        if (this.validateResponse[index]['target'] === 'card_token') {
          this.form.cardError = this.validateResponse[index]['message'];
          break;
        }
      }
      return this.form.cardError;
    },
  },
  watch  : {
    "form.bill_method"     : function () {
      this.$emit('input', this.form);
      this.$emit('changeBillMethod', this.form.bill_method);
      this.removeValidationResponseMessage('card_token');
      this.form.cardError = null;
    },
    "form.cardToken"       : function () {
      this.$emit('input', this.form);
      this.removeValidationResponseMessage('card_token');
      this.form.cardError = null;
    },
    "form.cardNumber"      : function () {
      this.$emit('input', this.form);
      this.removeValidationResponseMessage('card_token');
      this.form.cardError = null;
    },
    "form.cardExpireMonth" : function () {
      this.$emit('input', this.form);
      this.removeValidationResponseMessage('card_token');
      this.form.cardError = null;
    },
    "form.cardExpireYear"  : function () {
      this.$emit('input', this.form);
      this.removeValidationResponseMessage('card_token');
      this.form.cardError = null;
    },
    "form.cardHolder"      : function () {
      this.$emit('input', this.form);
      this.removeValidationResponseMessage('card_token');
      this.form.cardError = null;
    },
    "form.cardSecurityCode": function () {
      this.$emit('input', this.form);
      this.removeValidationResponseMessage('card_token');
      this.form.cardError = null;
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
